module.exports = __webpack_public_path__ + "img/PR4.aaca78ad.gif";